import * as apiValues from '../constants/apiValues';
import * as helpers from '../helpers';
import * as pageProgramsMapActions from '../actions/pageProgramsMapActions';
import DocumentTitle from './DocumentTitle';
import MapProgram from './MapProgram';
import MBreadcrumbs from './MBreadcrumbs';
import PageBase from './PageBase';
import PropTypes from 'prop-types';
import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from '../withRouterCompat';
import {
  fetchMapConfig,
  getProgramMapTabs,
  programSlugToMapContext,
} from '../utils/mapConfigTabs';


class PageProgramsMap extends React.Component{
  lastUrl = '';

  constructor(props){
    super(props);
    this.state = {
      mapTabs: null,
      mapConfigError: null,
    };
  }

  componentDidMount(){
    this.fetchContent();
  }
  componentDidUpdate(){
    if(this.props.match.url != this.lastUrl) this.fetchContent();
  }


  fetchContent(){
    this.lastUrl = this.props.match.url;
    const slug = this.props.match.params.slug;
    const mapContext = programSlugToMapContext(slug);

    if(!mapContext){
      helpers.handle404(this.props.history);
      return;
    }

    this.setState({ mapTabs: null, mapConfigError: null });

    Promise.all([
      this.props.actions.initPageProgramsMaps(slug),
      fetchMapConfig(),
    ])
      .then(([, config]) => {
        const mapTabs = getProgramMapTabs(config.layerGroups, slug);
        if(mapTabs.length === 0){
          throw new Error(`No map tabs configured for program "${slug}"`);
        }
        this.setState({ mapTabs });
      })
      .catch(() => {
        helpers.handle404(this.props.history);
      });
  }


  renderBreadcrumbs(){
    if(!this.props.page.program) return null;

    const slug = this.props.match && this.props.match.params && this.props.match.params.slug;
    let mBreadcrumbs = {
      pageChain: [
        {browserTitle: 'Home', slug: ''},
        {browserTitle: this.props.page.program.title, slug: `programs/${slug}`},
        {browserTitle: 'Maps', slug: '#'},
      ],
    };

    return (<MBreadcrumbs className="coupling coupling--full-centered m-breadcrumbs--project-details" mBreadcrumbs={mBreadcrumbs}/>);
  }
  render(){
    const slug = this.props.match && this.props.match.params && this.props.match.params.slug;
    const mapContext = programSlugToMapContext(slug);
    const title = apiValues.buildTitle(
      this.props.page?.program?.title ? `${this.props.page.program.title} Map` : 'Program Map',
    );

    if(!this.props.page ||
       !this.props.page.id ||
       !this.props.page.program ||
       !mapContext ||
       !this.state.mapTabs){
      return <DocumentTitle title={title}/>;
    }

    return (
      <PageBase>
        <DocumentTitle title={title}/>
        {this.renderBreadcrumbs()}
        <MapProgram mode={mapContext}
                    tabs={this.state.mapTabs}
                    history={this.props.history}
                    location={this.props.location}
                    match={this.props.match}/>
      </PageBase>
    );
  }
}


export default withRouter(connect(
  (state) => ({
    page: state.page,
  }),
  (dispatch) => ({
    actions: bindActionCreators(pageProgramsMapActions, dispatch),
  }),
)(PageProgramsMap));


PageProgramsMap.propTypes = {
  actions: PropTypes.object.isRequired,
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
};
